module.exports = __webpack_public_path__ + "img/one.280c96d3.png";